import React, {useEffect, useState} from 'react';
import './SelectCar.scss';
import parchamIran from '../../../Assets/svg/parchamIran.svg';
import NumericFunction from "../../../utils/NumericFunction";
import numericFunction from "../../../utils/NumericFunction";

const SelectCar = ({OpenModalToSelectCar, sendData, factorData, sendDataSetter, setFactorData}) => {

    const [pelak, setPlack] = useState([])
    const deleteHandler = () => {
        sendDataSetter({IDKHODRO: ''});
        setFactorData({});
    }

    useEffect(() => {
        if (factorData?.rLookUpData?.na_16 !== undefined) {
            setPlack(numericFunction.e2p(factorData?.rLookUpData?.na_16).split(""))
        }
    }, [factorData])

    const clickHandler = () => {

        if (sendData.status === "inQueue") {
            sendDataSetter({status: "inProcess"})
        } else {
            sendDataSetter({status: "inQueue"})
        }
    }
    console.log(factorData)
    return (
        <>
            <div className='select-car-parent'>
                <div className='select-auto-box'>
                    <button
                        className='select-auto'
                        onClick={OpenModalToSelectCar}>انتخاب خوردو
                    </button>
                    <button className='delet__btn' onClick={deleteHandler}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.9997 6.72998C20.9797 6.72998 20.9497 6.72998 20.9197 6.72998C15.6297 6.19998 10.3497 5.99998 5.11967 6.52998L3.07967 6.72998C2.65967 6.76998 2.28967 6.46998 2.24967 6.04998C2.20967 5.62998 2.50967 5.26998 2.91967 5.22998L4.95967 5.02998C10.2797 4.48998 15.6697 4.69998 21.0697 5.22998C21.4797 5.26998 21.7797 5.63998 21.7397 6.04998C21.7097 6.43998 21.3797 6.72998 20.9997 6.72998Z"
                                fill="#FB6B7A"/>
                            <path
                                d="M8.50074 5.72C8.46074 5.72 8.42074 5.72 8.37074 5.71C7.97074 5.64 7.69074 5.25 7.76074 4.85L7.98074 3.54C8.14074 2.58 8.36074 1.25 10.6907 1.25H13.3107C15.6507 1.25 15.8707 2.63 16.0207 3.55L16.2407 4.85C16.3107 5.26 16.0307 5.65 15.6307 5.71C15.2207 5.78 14.8307 5.5 14.7707 5.1L14.5507 3.8C14.4107 2.93 14.3807 2.76 13.3207 2.76H10.7007C9.64074 2.76 9.62074 2.9 9.47074 3.79L9.24074 5.09C9.18074 5.46 8.86074 5.72 8.50074 5.72Z"
                                fill="#FB6B7A"/>
                            <path
                                d="M15.2104 22.7501H8.79039C5.30039 22.7501 5.16039 20.8201 5.05039 19.2601L4.40039 9.19007C4.37039 8.78007 4.69039 8.42008 5.10039 8.39008C5.52039 8.37008 5.87039 8.68008 5.90039 9.09008L6.55039 19.1601C6.66039 20.6801 6.70039 21.2501 8.79039 21.2501H15.2104C17.3104 21.2501 17.3504 20.6801 17.4504 19.1601L18.1004 9.09008C18.1304 8.68008 18.4904 8.37008 18.9004 8.39008C19.3104 8.42008 19.6304 8.77007 19.6004 9.19007L18.9504 19.2601C18.8404 20.8201 18.7004 22.7501 15.2104 22.7501Z"
                                fill="#FB6B7A"/>
                            <path
                                d="M13.6601 17.25H10.3301C9.92008 17.25 9.58008 16.91 9.58008 16.5C9.58008 16.09 9.92008 15.75 10.3301 15.75H13.6601C14.0701 15.75 14.4101 16.09 14.4101 16.5C14.4101 16.91 14.0701 17.25 13.6601 17.25Z"
                                fill="#FB6B7A"/>
                            <path
                                d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z"
                                fill="#FB6B7A"/>
                        </svg>
                    </button>
                </div>

                <div className={"select__car__type"}>
                    <div className='plak_iran'>
                        ایـران
                        <div className="iran-number">
                            <li>{pelak[7]}</li>
                            <li>{pelak[6]}</li>
                        </div>
                    </div>
                    <div className='plak_content'>
                        <ul>
                            <li>{pelak[5]}</li>
                            <li>{pelak[4]}</li>
                            <li>{pelak[3]}</li>
                            <li>{pelak[2]}</li>
                            <li>{pelak[1]}</li>
                            <li>{pelak[0]}</li>
                        </ul>
                    </div>
                    <div className='plak_number'>
                        <div className='ax__'>
                            <img src={parchamIran} alt='parchamIran'/>
                        </div>
                    </div>

                </div>
                <div className='car_owner'>
                    <div className='car_owner_right'>

                        <div className='car_owner_left'>
                            <span>{factorData?.rLookUpData?.na_20 !== undefined ? "" + NumericFunction.e2p(factorData?.rLookUpData?.na_20) + "" : ""}</span>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15 22.75H9C4.59 22.75 3.25 21.41 3.25 17V7C3.25 2.59 4.59 1.25 9 1.25H15C19.41 1.25 20.75 2.59 20.75 7V17C20.75 21.41 19.41 22.75 15 22.75ZM9 2.75C5.42 2.75 4.75 3.43 4.75 7V17C4.75 20.57 5.42 21.25 9 21.25H15C18.58 21.25 19.25 20.57 19.25 17V7C19.25 3.43 18.58 2.75 15 2.75H9Z"
                                    fill="#646464"/>
                                <path
                                    d="M14 6.25H10C9.59 6.25 9.25 5.91 9.25 5.5C9.25 5.09 9.59 4.75 10 4.75H14C14.41 4.75 14.75 5.09 14.75 5.5C14.75 5.91 14.41 6.25 14 6.25Z"
                                    fill="#646464"/>
                                <path
                                    d="M12.0002 19.86C10.7302 19.86 9.7002 18.83 9.7002 17.56C9.7002 16.29 10.7302 15.26 12.0002 15.26C13.2702 15.26 14.3002 16.29 14.3002 17.56C14.3002 18.83 13.2702 19.86 12.0002 19.86ZM12.0002 16.75C11.5602 16.75 11.2002 17.11 11.2002 17.55C11.2002 17.99 11.5602 18.35 12.0002 18.35C12.4402 18.35 12.8002 17.99 12.8002 17.55C12.8002 17.11 12.4402 16.75 12.0002 16.75Z"
                                    fill="#646464"/>
                            </svg>
                        </div>

                        <div className="box-status">
                            <p onClick={clickHandler}
                               className={`${sendData.status === "inQueue" ? "border-color" : ""}`}>در صف انتظار</p>

                            <p onClick={clickHandler}
                               className={`${sendData.status === "inProcess" ? "border-color" : ""}`}>در حال شسمت و
                                شو</p>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default SelectCar;
